import React from 'react';

import Col from 'react-bootstrap/Col';
import postData from '../../utilities/postData';
import ListView from '../shared/lists/ListView';
import Form from 'react-bootstrap/Form';
import PagedListControl from '../shared/lists/PagedListControl';
import Row from 'react-bootstrap/Row';
import SortableTh from '../shared/table/SortableTh';
import useFilter from '../../utilities/useFilter';
import FranchiseItem from './FranchiseItem';
import SearchBar from '../shared/search/SearchBar';

const FranchiseView = (props) => {
    const getUrl = '/api/franchises/list';

    const { items, submitFilter, pageInfo, canCreate, filter, setFilter } = useFilter(getUrl,
        {
            searchString: '',
            searchObject: {
                name: 'na',
                isEnabled: true
            }
        }, true);

    const enableItem = (id) => postData('/api/franchises/enable', id, submitFilter);
    const disableItem = (id) => postData('/api/franchises/disable', id, submitFilter);

    const tableHead = (
        <thead>
            <tr>
                <SortableTh
                    content="Name"
                    sortName="Name"
                    sort={pageInfo}
                />
                <SortableTh
                    content="Number"
                    sortName="Number"
                    sort={pageInfo}
                />
                <SortableTh
                    content="Status"
                    sortName="IsEnabled"
                    sort={pageInfo}
                    width={'75px'}
                />
                <th className="two-button-cell">
                </th>
            </tr>
        </thead>
    );

    const itemList = items.map((item) =>
        <FranchiseItem
            item={item}
            key={item.id}
            editItem={() => window.location = `/franchises/edit/${item.id}`}
            disableItem={() => disableItem(item.id)}
            enableItem={() => enableItem(item.id)}
            acl={item.acl}
        />
    );

    return (
        <React.Fragment>
            <SearchBar filter={filter} setFilter={setFilter} submitFilter={submitFilter}>
                <Col xs="auto">
                    <div className="d-flex pl-sm-5" style={{ paddingTop: '5px' }}>
                        <label className="custom-control custom-checkbox d-inline-flex">
                            <input
                                checked={filter.searchObject && filter.searchObject.isEnabled || false}
                                className="custom-control-input"
                                name="searchObject.isEnabled"
                                onChange={(e) => {
                                    setFilter(e);
                                    submitFilter();
                                }}
                                type="checkbox"
                            />
                            <span className="custom-control-label">&nbsp;</span>
                        </label>
                        <label style={{ marginLeft: '-5px' }}>
                            Hide Disabled
                        </label>
                    </div>
                </Col>
            </SearchBar>
            <ListView
                addItem={() => window.location = "/franchises/edit/0"}
                canAdd={canCreate}
                itemName="Franchise"
                items={itemList}
                tableHead={tableHead}
                animate={false}
            />
            <Row className="mt-4">
                <Col>
                    <PagedListControl {...pageInfo} />
                </Col>
            </Row>
        </React.Fragment>
    );
}

export default FranchiseView;